import type { AnalyticsSink } from "@yjsgames/analytics-ports";
import { AnalyticsEvent } from "./analyticsEvents.js";

/**
 * 1회성 마일스톤 게이트 최소 인터페이스 — analytics→systems 직접 의존을 끊어 helper를 leaf로 유지(레이어 경계).
 * AnalyticsMilestoneController가 구조적으로 충족한다(markOnce).
 */
interface MilestoneGate {
  markOnce(key: string): boolean;
}

/**
 * 첫 구매(상자/일일상점/IAP 공통) 1회 first_purchase 발화 — 마일스톤 dedup (funnel #9).
 * 모든 구매 경로(economyCommands·dailyShopCommands·IapFlow)가 `purchase` 발화 직후 호출해
 * 계정 생애 첫 구매에만 first_purchase를 1회 보낸다. 마일스톤은 SaveData 영속이라 reload·재방문에도 재발화 안 함.
 */
export function trackFirstPurchase(
  analytics: AnalyticsSink,
  milestones: MilestoneGate,
): void {
  if (milestones.markOnce(AnalyticsEvent.FirstPurchase)) {
    analytics.log(AnalyticsEvent.FirstPurchase);
  }
}
